import React from 'react';
import { orderBy } from 'lodash';
import LineWithRingsLegend from '../LineWithRingsLegend';

import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardSubtitle,
} from 'reactstrap';
import QuestionResults from '../QuestionResults';

function Variability({ variance }) {
  const stdDev = Math.sqrt(variance);

  if (stdDev > 0.3) {
    return <span className="text-danger">HIGH</span>;
  } else if (stdDev > 0.15) {
    return <span className="text-warn">MEDIUM</span>;
  } else {
    return <span className="text-success">LOW</span>;
  }
}

function MostContentious({
  assessment,
  questions,
  filter,
  cohorts,
  activeCohort,
  participantCohortMap,
  legendFields,
  pinnedCohort,
  peekedCohort,
  onPinCohort,
  onClearPinnedCohort,
  onPeekCohort,
  onClearPeekedCohort,
  breakoutName,
}) {
  const legendProps = {
    fields: legendFields,
    pinnedCohort,
    peekedCohort,
    onPinCohort,
    onClearPinnedCohort,
    onPeekCohort,
    onClearPeekedCohort,
    breakoutName,
  };

  const top5 = orderBy(
    questions,
    ['normalizedVariance', 'questionKey'],
    ['desc', 'asc']
  )
    .slice(0, 5)
    .map((stats) => {
      const question = assessment.question_sets
        .find((qs) => qs.key === stats.questionSetKey)
        ?.questions.find((q) => q.key === stats.questionKey);
      return { stats, question };
    });

  return (
    <Card tag="section">
      <CardHeader>
        <CardTitle tag="h5">Most contentious</CardTitle>
        <CardSubtitle>
          Looks like there's some disagreement with these. It might be worth
          digging deeper.
        </CardSubtitle>
      </CardHeader>
      <CardBody>
        {legendFields.length > 2 ? (
          <LineWithRingsLegend {...legendProps} />
        ) : null}
        <section className="survey-review-grid">
          {top5.map(({ stats, question: q }) => (
            <div key={q.id}>
              <div className="detail-overview-question-header">
                <h6 className="question-set-name">
                  {stats.questionSetDisplayName}
                </h6>
                <div
                  className="question-score"
                  // style={{ color: scaleColorTraffic(stats.normalizedScore) }}
                >
                  <Variability variance={stats.normalizedVariance} />
                  {/* {Math.round(stats.normalizedScore * 100 + Number.EPSILON)}/100 */}
                </div>
              </div>
              <QuestionResults
                question={q}
                filter={filter}
                participantCohortMap={participantCohortMap}
                cohorts={cohorts}
                activeCohort={activeCohort}
              />
            </div>
          ))}
        </section>
      </CardBody>
    </Card>
  );
}

export default MostContentious;
